import { Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { convertToMoney } from '@woovi/utils';
import type { PaymentMethodBoletoValue_charge$key } from './__generated__/PaymentMethodBoletoValue_charge.graphql.ts';

import PaymentMethodBoletoPixValue from './PaymentMethodBoletoPixValue.tsx';
import { useChargePaymentMethod } from '../../../charge/useChargePaymentMethod.tsx';

type PaymentMethodBoletoValueProps = {
  charge: PaymentMethodBoletoValue_charge$key;
};

const PaymentMethodBoletoValue = (
  props: PaymentMethodBoletoValueProps,
): ReactNode => {
  const { t } = useTranslation();

  const charge = useFragment<PaymentMethodBoletoValue_charge$key>(
    graphql`
      fragment PaymentMethodBoletoValue_charge on Charge {
        company {
          nameFriendly
        }
        value
        ...useChargePaymentMethod_charge
        ...PaymentMethodBoletoPixValue_charge
      }
    `,
    props.charge,
  );

  const { boleto, pix } = useChargePaymentMethod(charge);

  if (boleto && pix) {
    return <PaymentMethodBoletoPixValue charge={charge} />;
  }

  return (
    <Typography variant='h5' fontWeight='bold' textAlign='center'>
      {t('Pay {{value}} to {{companyName}} via Boleto', {
        value: convertToMoney(charge.value),
        companyName: charge?.company?.nameFriendly,
      })}
    </Typography>
  );
};

export default PaymentMethodBoletoValue;
